import React from "react";
import Img from "gatsby-image";

const Produto = ({ produto, imgFluid }) => {
  return (
    <div
      style={{ minWidth: "220px" }}
      className="m-2 rounded-md bg-teal-100 hover:shadow-lg transition ease-in-out duration-700 flex flex-col justify-center"
    >
      <Img className="h-48" fluid={imgFluid}></Img>

      <h3 className="text-center text-base">{produto.nome}</h3>
      <h3 className="text-center text-lg font-bold">R$ {produto.preco}</h3>
      <a
        role="button"
        className="text-center rounded-b-md bg-teal-400 hover:bg-teal-700 text-white font-bold py-2"
        rel="noopener noreferrer"
        target="_blank"
        href={
          "https://api.whatsapp.com/send?phone=5519993820824&text=Ol%C3%A1!%20Quero%20comprar:%0A1x - " +
          produto.nome +
          "%0APreço: R$ " +
          produto.preco
        }
      >
        COMPRAR
      </a>
    </div>
  );
};

export default Produto;
